module.exports = __webpack_public_path__ + "img/input_5.9f9330a2.png";